import { render, staticRenderFns } from "./BannerSetting.vue?vue&type=template&id=2a935aae&"
import script from "./BannerSetting.vue?vue&type=script&lang=js&"
export * from "./BannerSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a935aae')) {
      api.createRecord('2a935aae', component.options)
    } else {
      api.reload('2a935aae', component.options)
    }
    module.hot.accept("./BannerSetting.vue?vue&type=template&id=2a935aae&", function () {
      api.rerender('2a935aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/BannerSetting.vue"
export default component.exports